import { localize } from "../../../common/services/localization"
import { isNothing } from "../../../common/utils"
import { BlueButton, OrangeButton } from "../functional/buttons"
import { SadTinyImage } from "../ui/file-contents"

export const ServerErrorPage: React.FC<{
}> = () => {
    return <div className="flex flex-col xl:flex-row w-full p-[100px] min-h-screen items-center ">
        <div className="flex flex-col gap-y-[20px] text-start">
            <h2>
                технические работы
            </h2>
            <div className="flex flex-col gap-y-[60px]">
                <p className="text-28 font-['Roboto'] text-orange">
                    Попробуйте обновить страницу или зайти позже
                </p>
                <BlueButton
                    className="w-[294px] px-8 py-4"
                    localText="Обновить страницу"
                    onClick={() => window.location.reload()}
                />
            </div>
        </div>
        <SadTinyImage />
    </div>
}

export const NotFoundBlock: React.FC<{
    localText: string
    onClickBtn: () => void
    btnLocalText: string
    withImg?: boolean
}> = ({ localText, onClickBtn, btnLocalText, withImg }) => {

    const needImg = isNothing(withImg) ? true : withImg;

    return <div className="w-full max-w-[1560px] mx-auto h-[400px] flex items-center justify-between">
        <div className="flex flex-col gap-y-[20px]">
            <h2 className="">
                {localize(localText)}
            </h2>
            <BlueButton
                className="w-[294px] px-8 py-4 mx-auto 2xl:mx-0"
                localText={btnLocalText}
                onClick={onClickBtn}
            />
        </div>
        {
            needImg
                ? <SadTinyImage />
                : null
        }

    </div>
}